import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFour = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.2094 13.1568H12.6142V11.0832C12.6142 10.8144 12.6238 10.4976 12.643 10.1328C12.6622 9.768 12.6766 9.4512 12.6862 9.1824H12.6286C12.5134 9.4224 12.3934 9.6576 12.2686 9.888C12.1438 10.1184 12.0142 10.3584 11.8798 10.608L10.2094 13.1568ZM12.6142 16.8V14.4384H8.56781V13.3152L12.1966 7.6416H14.1694V13.1568H15.3214V14.4384H14.1694V16.8H12.6142Z",
		fill: "currentcolor"
	})]
});
export default SvgFour;
